import { useTranslation } from 'react-i18next';
import { Typography } from '@dagensmat/carrot/Components';
import styled from 'styled-components';
import { Container } from '@dagensmat/carrot/Layout';

type ProductsInBasketTotalProps = {
  subtotal: string;
};

const ProducerTotal = styled(Typography)`
  order: 1;
  text-align: right;
  flex: auto;
`;

const ProductsInBasketTotal = ({ subtotal }: ProductsInBasketTotalProps) => {
  const { t } = useTranslation();

  return (
    <Container flex>
      <Typography variant="paragraphSmall" style={{ order: 0, flex: 'none' }}>
        {t(`common:OrderTotal`)}
      </Typography>
      <ProducerTotal variant="paragraphSmall">{`${subtotal}`}</ProducerTotal>
    </Container>
  );
};

export default ProductsInBasketTotal;
